export const initialTeam = [];
